module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/insurance-income-protection-39637d0e1a073fa52f150cf8fcb851cd.svg";